import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import Spinner from "../../components/generics/Spinner";
import _ from "lodash";
import moment from 'moment';

import ReactPaginate from "react-paginate";

import ReportRecall from "../../components/reports/ReportRecall";
import ReportRecallFilter from "../../components/reports/ReportRecallFilter";
import ReportHeader from "../../components/generics/ReportHeader";

import {
  fetchInventoriesRecall,
  fetchInventoriesRecallSuccess,
  fetchInventoriesRecallFailure,
} from "../../store/inventories/actions";

import { fetchVendors, fetchVendorsSuccess, fetchVendorsFailure } from "../../store/invoices/actions";
import { fetchInventoriesRecallCSV } from "../../store/inventories/api";

import { DEBOUNCE_SEARCH } from "../../constants/constants";
import { withRouter } from "utils/WithRouter";

const EMPTY_FILTERS = {
  inventoryID: "",
  sessionID: "",
  lotID: "",
  shipmentID: "",
  plantID: "",
  vendor: null,
};

const ReportRecallContainer = ({
  location,
  history,
  inventoriesRecall,
  vendorsList,
  getFilteredInventories,
  getVendors,
}) => {
  const queryParams = new URLSearchParams(location.search);
  const [csvIsLoading, setcsvIsLoading] = useState(false);
  const [page, setPage] = useState(Number(queryParams.get("page")) || 1);
  const [filters, setFilters] = useState({
    inventoryID: queryParams.get("inventoryID") || "",
    sessionID: queryParams.get("sessionID") || "",
    lotID: queryParams.get("lotID") || "",
    shipmentID: queryParams.get("shipmentID") || "",
    plantID: queryParams.get("plantID") || "",
    vendor: queryParams.get("vendor") || null,
  });

  const isEmptyFilters = () => {
    return Object.values(filters).every((filter) => filter === "" || filter == null);
  };

  useEffect(() => {
    getFilteredInventories(page, filters);
    getVendors();
  }, []);

  const updateQuery = (filters) => {
    const currentParams = new URLSearchParams(location.search);

    Object.entries(filters).forEach(([key, value]) => {
      if (value === null || value === "") {
        currentParams.delete(key);
      } else {
        currentParams.set(key, value.toString());
      }
    });

    history.replace({ search: currentParams.toString() });
  };

  const debouncedFilterChange = useCallback(
    _.debounce((updatedFilters) => {
      getFilteredInventories(1, updatedFilters);
    }, DEBOUNCE_SEARCH),
    []
  );

  const handleFilterChange = (field, value) => {
    const updatedFilters = { ...filters, [field]: value };
    setFilters(updatedFilters);
    updateQuery(updatedFilters);
    debouncedFilterChange(updatedFilters);
  };

  const handleVendorChange = (value) => {
    let vendor = value && value > -1 ? value : null;
    const updatedFilters = { ...filters, vendor: vendor };
    setFilters(updatedFilters);
    updateQuery(updatedFilters);
    debouncedFilterChange(updatedFilters);
  };

  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    getFilteredInventories(newPage, filters);
    updateQuery({ page: newPage });
    setPage(newPage);
  };

    // ---------------------------------------------------------------------------
    // CSV
    // ---------------------------------------------------------------------------
  
  const loadCsv = () => {
    let fileName = `test.csv`
    setcsvIsLoading(true)
    console.log(filters)
    fetchInventoriesRecallCSV(filters).then((r) => {
      let blob = new Blob([r.data], { type: 'text/csv' })
      let link = document.createElement('a')
      document.body.appendChild(link);
      link.href = window.URL.createObjectURL(blob)
      link.setAttribute('download', fileName);
      link.click();
      document.body.removeChild(link);
      setcsvIsLoading(false)
    }).catch((err) => {
      console.log(err);
      setcsvIsLoading(false)
    });
  };

  return (
    <div>
      <div className="card mb-2">
        <ReportHeader
          title="Recall Report"
          actionTitle="Export CSV"
          actionClass="btn btn-primary m-0"
          csvLoading={csvIsLoading}
          fromFile={true}
          loadCsv={loadCsv}
        />
        <ReportRecallFilter
          searchLabel="Search Item"
          searchPlaceholder="Search by ID"
          searchVal={filters.inventoryID}
          onSearchChange={(e) =>
            handleFilterChange("inventoryID", e.target.value)
          }
          searchLabel2="Search Production session"
          searchPlaceholder2="Search by session ID"
          searchVal2={filters.sessionID}
          onSearchChange2={(e) =>
            handleFilterChange("sessionID", e.target.value)
          }
          searchLabel3="Search shipment ID"
          searchPlaceholder3="Search by shipment ID"
          searchVal3={filters.shipmentID}
          onSearchChange3={(e) =>
            handleFilterChange("shipmentID", e.target.value)
          }
          searchLabel4="Lot"
          searchPlaceholder4="Search by lot ID"
          searchVal4={filters.lotID}
          onSearchChange4={(e) => handleFilterChange("lotID", e.target.value)}
          searchLabel5="Plant"
          searchPlaceholder5="Search by plant ID"
          searchVal5={filters.plantID}
          onSearchChange5={(e) => handleFilterChange("plantID", e.target.value)}
          dropdownLabel="Vendor"
          dropdownPlaceholder="Select vendor"
          dropdownVal={filters.vendor}
          onDropdownChange={(e) => handleVendorChange(e.target.value)}
          dropdownByElementId
          dropdownOptions={vendorsList ? vendorsList.vendors.results : []}
          colClass="col-12 col-sm-3"
        />
      </div>
      <ReportRecall
        inventoriesList={inventoriesRecall.inventories}
        noFilters={isEmptyFilters()}
      />
      {!inventoriesRecall.loading && inventoriesRecall.pages > 1 && (
        <ReactPaginate
          pageCount={inventoriesRecall.pages}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          previousLabel="<"
          nextLabel=">"
          onPageChange={handlePageChange}
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="page-item active"
          previousClassName="paginate_button previous"
          nextClassName="paginate_button next"
          disabledClassName="page-item disabled"
          forcePage={page - 1}
        />
      )}
      {inventoriesRecall.loading && <Spinner />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  inventoriesRecall: state.inventories.inventoriesRecall,
  vendorsList: state.invoices.vendorsList,
  }
);

const mapDispatchToProps = (dispatch) => {
  return {
  getFilteredInventories: (
    page,
    { inventoryID, sessionID, lotID, shipmentID, plantID, vendor }
  ) => {
    dispatch(
      fetchInventoriesRecall(page, inventoryID, sessionID, lotID, shipmentID, plantID, vendor)
    ).payload.then(
      (response) => dispatch(fetchInventoriesRecallSuccess(response.data)),
      (error) => dispatch(fetchInventoriesRecallFailure(error))
    );
  },
  getVendors: () => {
    dispatch(fetchVendors()).payload.then(
      (response) => {
        dispatch(fetchVendorsSuccess(response.data));
      },
      (error) => {
        dispatch(fetchVendorsFailure(error));
      }
    );
  },
}};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ReportRecallContainer));
